/* Seed Vault Kit PDP — vanilla JS. Bridges mockup controls to the theme's native <product-form> (product-form.js) and cart drawer. */
(function () {
  'use strict';
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDec = whole + '.' + parts[1];
    var noDec = String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, withDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec.replace(/,/g, ' ').replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec.replace(/,/g, '.'));
  }

  function initBuyBox(root) {
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-svk-variants]').textContent); } catch (e) {}
    var form = root.querySelector('form[data-svk-product-form]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var qtyOut = root.querySelector('[data-svk-qty-out]');
    var atc = form.querySelector('[data-svk-atc]');
    var atcText = atc ? atc.querySelector('[data-svk-atc-text]') : null;
    var priceEls = document.querySelectorAll('[data-svk-price]');
    var compareEls = root.querySelectorAll('[data-svk-compare]');
    var badgeEl = root.querySelector('[data-svk-savings]');
    var priceRow = root.querySelector('[data-svk-price-row]');
    var stickyBtn = root.querySelector('[data-svk-sticky-submit]');
    var sticky = root.querySelector('[data-svk-sticky]');
    var stickyQty = root.querySelector('[data-svk-sticky-qty]');
    var ctaLabel = root.dataset.ctaLabel || 'Add to cart';
    var soldOutLabel = root.dataset.soldOutLabel || 'Sold out';
    var unavailableLabel = root.dataset.unavailableLabel || 'Unavailable';

    function currentVariant() {
      var id = idInput && idInput.value;
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return variants[0];
    }
    function qty() { return Math.max(1, parseInt(qtyInput.value, 10) || 1); }

    function render() {
      var v = currentVariant();
      if (!v) return;
      var q = qty();
      priceEls.forEach(function (el) { el.textContent = formatMoney(v.price, moneyFormat); });
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      compareEls.forEach(function (el) { el.textContent = onSale ? formatMoney(v.compare_at_price, moneyFormat) : ''; });
      if (badgeEl) badgeEl.textContent = onSale ? (root.dataset.saveLabel || 'Save') + ' ' + formatMoney(v.compare_at_price - v.price, moneyFormat) : '';
      if (priceRow) priceRow.setAttribute('data-on-sale', onSale ? 'true' : 'false');
      if (qtyOut) qtyOut.textContent = q;
      if (stickyQty) stickyQty.textContent = q;
      if (atc && atcText) {
        if (!v.available) {
          atc.setAttribute('disabled', 'disabled');
          atcText.textContent = soldOutLabel;
        } else {
          atc.removeAttribute('disabled');
          atcText.textContent = ctaLabel;

        }
      }
      if (stickyBtn) stickyBtn.disabled = !v.available;
    }

    root.querySelectorAll('[data-svk-qty-dec]').forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = Math.max(1, qty() - 1); qtyInput.dispatchEvent(new Event('change', { bubbles: true })); render(); });
    });
    root.querySelectorAll('[data-svk-qty-inc]').forEach(function (b) {
      b.addEventListener('click', function () { var max = parseInt(qtyInput.max, 10) || 99; qtyInput.value = Math.min(max, qty() + 1); qtyInput.dispatchEvent(new Event('change', { bubbles: true })); render(); });
    });

    var optionInputs = root.querySelectorAll('[data-svk-option]');
    if (optionInputs.length) {
      var selectedOptions = function () {
        var out = [];
        root.querySelectorAll('fieldset[data-svk-option-index]').forEach(function (fs) {
          var checked = fs.querySelector('input:checked');
          out.push(checked ? checked.value : null);
        });
        return out;
      };
      var onOptionChange = function () {
        var sel = selectedOptions();
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < sel.length; j++) if (variants[i].options[j] !== sel[j]) { ok = false; break; }
          if (ok) { match = variants[i]; break; }
        }
        if (match) {
          idInput.value = match.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          if (window.history && history.replaceState) {
            var url = new URL(window.location.href); url.searchParams.set('variant', match.id); history.replaceState({}, '', url.toString());
          }
          if (match.featured_media_position) selectImage(match.featured_media_position - 1);
          render();
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.variantChange, { source: 'svk-buy-box', data: { variant: match } });
        } else if (atc && atcText) {
          atc.setAttribute('disabled', 'disabled'); atcText.textContent = unavailableLabel;
        }
      };
      optionInputs.forEach(function (i) { i.addEventListener('change', onOptionChange); });
    }

    var stageImg = root.querySelector('[data-svk-stage-img]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-svk-thumb]'));
    var current = 0;
    function selectImage(i) {
      if (!thumbs.length) return;
      current = (i + thumbs.length) % thumbs.length;
      var t = thumbs[current];
      if (stageImg) {
        stageImg.src = t.dataset.full;
        if (t.dataset.srcset) stageImg.srcset = t.dataset.srcset; else stageImg.removeAttribute('srcset');
        stageImg.alt = t.dataset.alt || '';
      }
      thumbs.forEach(function (b, j) { b.setAttribute('aria-selected', j === current ? 'true' : 'false'); b.tabIndex = j === current ? 0 : -1; });
    }
    thumbs.forEach(function (b, i) {
      b.addEventListener('click', function () { selectImage(i); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); selectImage(i + 1); thumbs[current].focus(); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); selectImage(i - 1); thumbs[current].focus(); }
      });
    });
    root.querySelectorAll('[data-svk-prev]').forEach(function (b) { b.addEventListener('click', function () { selectImage(current - 1); }); });
    root.querySelectorAll('[data-svk-next]').forEach(function (b) { b.addEventListener('click', function () { selectImage(current + 1); }); });

    function remoteSubmit() {
      if (!atc || atc.disabled) return;
      if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
    }
    if (stickyBtn) stickyBtn.addEventListener('click', remoteSubmit);
    document.querySelectorAll('[data-svk-remote-submit]').forEach(function (b) { b.addEventListener('click', remoteSubmit); });
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(atc);
    }

    if (idInput) idInput.addEventListener('change', render);
    render();
  }

  function initAccordions(scope) {
    scope.querySelectorAll('[data-svk-acc]').forEach(function (btn) {
      if (btn.dataset.svkReady) return; btn.dataset.svkReady = '1';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var icon = btn.querySelector('.svk-acc-icon');
      function set(open) { btn.setAttribute('aria-expanded', open ? 'true' : 'false'); panel.hidden = !open; if (icon) icon.textContent = open ? '\u2212' : '+'; }
      set(btn.getAttribute('aria-expanded') === 'true');
      btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
    });
  }

  function init() {
    document.querySelectorAll('[data-svk-buy-box]').forEach(function (root) { if (!root.dataset.svkReady) { root.dataset.svkReady = '1'; initBuyBox(root); } });
    initAccordions(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
